import { connect } from 'react-redux';
import TruckFormComponent from './TruckFormComponent';
import { LoadingRestriction } from '../../models/loading-restriction';
import { Dictionary, Options } from '../../models/utils';
import { StoreState } from '../../store/state';

const defaultLinehaulCompany = {
  value: '',
  label: 'None',
};

const defaultCustomsBroker = {
  value: '',
  label: 'Can be selected at manifesting...',
};

const loadingRestrictionNames: { [k: string]: string; } = {
  'ShipmentQualifierTruckLoadingRestriction::tariff-category': 'shipment restrictions',
  'ShipmentQualifierTruckLoadingRestriction::carrier-account': 'carrier restrictions',
};

export const groupLoadingRestrictions =
  (loadingRestrictions: Dictionary<Dictionary<LoadingRestriction>>) => {
    const categories: Dictionary<{ name: string; all: Options; }> = {};
    for (const loadingRestrictionType of Object.keys(loadingRestrictions)) {
      if (!categories[loadingRestrictionType]) {
        categories[loadingRestrictionType] = {
          name: loadingRestrictionNames[loadingRestrictionType],
          all: Object.values(loadingRestrictions[loadingRestrictionType])
            .map(({ displayValue, value }) => ({ value, label: displayValue })),
        };
      }
    }
    return categories;
  };

export const mapStateToProps = (state: StoreState) => ({
  selectedLocationKey: state.location.key,
  linehaulCompanies: [
    defaultLinehaulCompany,
    ...Object.values(state.linehaulCompanies.all).map(({ id, name }) => ({ label: name, value: id })) || [],
  ],
  customsBrokers: [defaultCustomsBroker],
  truckLoadingRestrictions: groupLoadingRestrictions(state.loadingRestrictions.all || []),
});

export default connect(
  mapStateToProps,
)(TruckFormComponent);
